import { reactive, readonly } from 'vue';
import { getRoleById } from '@/service/admin-service.js';
import environmentData from '@/store/enviroment-data.js';

const { state: environmentState } = environmentData;

const MODE = readonly({
    VIEW: 0,
    CREATE: 1,
    UPDATE: 2,
});

const UI_ELEMENTS_IDS = readonly({
    ROLES_GRID: 727,
    CARD: 728,
});

const state = reactive({
    areas: [], // role areas
    areasByCurrentAppId: [],
    currentAppId: null,
    apps: [],
    formData: {
        appId: null,
        code: '',
        description: '',
        name: '',
    },
    refreshRolesGrid: false,
    mode: MODE.CREATE,
    id: null,
    appId: null,
    appIds: [],
    selectedApps: [],
    rolePopupVisible: false,
    areaPopupVisible: false,
    loadedCode: '', // used for validation
    formRef: null, // description form ref
    initialCode: '',
    areaGridInstance: null,
    isDataLoaded: true,
    isClosingConfirmed: true,
    requestBodyHasNotChanged: true,
    stopWatching: null,
});

const clearRoleData = () => {
    state.formData = {
        appId: null,
        code: '',
        description: '',
        name: '',
    };
    state.areas = [];
    state.currentAppId = null;
    state.areasByCurrentAppId = [];
    state.apps = environmentState.appList;
};

const isNotSystemRole = () => state.formData.code !== '-1';

const addAreas = newArea => {
    state.areas = [...newArea, ...state.areas];
    state.areasByCurrentAppId = state.areas.filter(area => area.app_id === state.formData.appId);
};

const loadById = async (roleId, appIds) => {
    state.appIds = appIds;
    const result = await getRoleById({ roleId });
    if (result) {
        const { areas, code, description, name, id } = result;
        areas?.forEach(area => (area.displayId = `${area.id}:a`));
        state.id = id;
        state.areas = areas;
        state.areasByCurrentAppId = state.areas.filter(area => area.app_id === appIds[0]);
        state.apps = environmentState.appList.filter(appItem => appIds.includes(appItem.kod_app));
        state.formData = { appId: appIds[0], code, description, name };
        state.initialCode = code;

        if (!state.areas) state.areas = [];
        state.loadedCode = code;
    }
};

const filterAreasByAppId = () => {
    if (state.mode === MODE.CREATE) state.areas.forEach(area => area.app_id = state.formData.appId);
    state.areasByCurrentAppId = state.areas.filter(area => area.app_id === state.formData.appId);
};

const copyById = async (roleId, appId) => {
    const result = await getRoleById({ roleId });
    if (result) {
        const { areas, description, name } = result;
        areas.forEach(area => (area.displayId = `${area.id}:a`));
        state.areas = areas;
        state.areasByCurrentAppId = areas;
        state.apps = environmentState.appList;
        state.formData = { appId, description, name };

        if (!state.areas) state.areas = [];
    }
};

export default {
    MODE,
    UI_ELEMENTS_IDS,
    state,
    clearRoleData,
    addAreas,
    loadById,
    filterAreasByAppId,
    copyById,
    isNotSystemRole,
};
